// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__F35bt","left":"InfoRow_left__1jSum"};